// @flow
import * as React from 'react'

import get from 'lodash/get'
import Strings from '@/constants'
import { Paper, Tabs } from '@/components'
import tabStyles from '@/components/tabs/styles.scss'
import { Property } from '@/models'
import { RoomTab, FacilitiesTab, DiningTab } from './tabs'
import styles from '../styles.scss'

type PropertyInfoProps = {
  property: Property,
  chooseRoom: (roomId: string, rateId: string, checkLink: string) => void,
  goBack: () => void,
}

export const PropertyInfo = ({ property, chooseRoom, goBack }: PropertyInfoProps) => {
  const { rooms, descriptions, name } = property.metadata

  const diningAndEntertainment = get(property, 'dining_and_entertainment')

  const tabs = [
    {
      activeAccessory: [],
      inactiveAccessory: [],
      title: Strings.hotelInfo.room,
      content: [
        <RoomTab code={property.code || ''} name={name} rooms={rooms} chooseRoom={chooseRoom} goBack={goBack} />
      ],
      className: tabStyles.smallMarginMobile,
      noPaper: true,
    },
    {
      activeAccessory: [],
      inactiveAccessory: [],
      title: Strings.hotelInfo.diningAndEntertainment,
      content: [<DiningTab description={diningAndEntertainment || descriptions.dining} />],
      className: tabStyles.smallMarginMobile,
    },
    {
      activeAccessory: [],
      inactiveAccessory: [],
      title: Strings.hotelInfo.facilities,
      content: [<FacilitiesTab property={property} />],
      className: tabStyles.smallMarginMobile,
    },
  ]

  return (
    <div className={styles.contentContainer}>
      <Paper className={styles.hotelInfoPaper} isColumn>
        <span className={styles.nameMobile}>{name}</span>
        {descriptions.headline && <p>{descriptions.headline}</p>}
        {descriptions.location && <p>{descriptions.location}</p>}
        {descriptions.amenities && <p>{descriptions.amenities}</p>}
      </Paper>
      <div className={styles.hotelInfoTabs}>
        <Tabs tabs={tabs} />
      </div>
    </div>
  )
}

export default PropertyInfo
